import { IEquipmentTypes } from '../../types'

export const EQUIPMENT_OPTIONS = [
  {
    label: 'Any Equipment',
    value: IEquipmentTypes.anyEquipment,
  },
  {
    label: 'Dry Van',
    value: IEquipmentTypes.dryVan,
  },
  {
    label: 'Reefer',
    value: IEquipmentTypes.reefer,
  },
  {
    label: 'Open Deck',
    value: IEquipmentTypes.openDeck,
  },
]
